import React from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../common/icon';

const MembershipActions = props => (
  <div className="u-position-relative c-membership-actions-container">
    <Icon
      glyph={GLYPHS.membershipsOptions}
      className="u-mr u-cursor-pointer"
    />
    <div className="c-membership-actions" data-automation-id={`membership-item-actions-${props.membership.id}`}>
      <button
        display-if={props.canViewMembership}
        type="button"
        className="c-membership-actions-option"
        onClick={e => props.viewMembership(e, props.membership)}
      >
        View Membership
      </button>
      <button
        display-if={props.canEditMembership}
        type="button"
        className="c-membership-actions-option"
        onClick={e => props.editMembership(e, props.membership)}
      >
        Edit
      </button>
      <button
        display-if={props.canCopyMembership}
        type="button"
        className="c-membership-actions-option"
        onClick={e => props.copyMembership(e, props.membership)}
      >
        Duplicate
      </button>
      <button
        display-if={props.canArchiveMembership}
        type="button"
        className="c-membership-actions-option"
        onClick={e => props.archiveMembership(e, props.membership)}
      >
        Archive
      </button>
    </div>
  </div>
);

MembershipActions.propTypes = {
  membership: PropTypes.object.isRequired,
  editMembership: PropTypes.func.isRequired,
  viewMembership: PropTypes.func.isRequired,
  copyMembership: PropTypes.func.isRequired,
  archiveMembership: PropTypes.func.isRequired,
  canEditMembership: PropTypes.bool.isRequired,
  canViewMembership: PropTypes.bool.isRequired,
  canCopyMembership: PropTypes.bool.isRequired,
  canArchiveMembership: PropTypes.bool.isRequired,
};

export default MembershipActions;
